import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LogoDooddo from '../../../../assets/white_logo.png';
import clsx from 'clsx';
import styles from "./styles";
import { AUTH_USERS_NAME, AUTH_CREDENTIALS_NAME } from "./../../../../Constantes";
import { useHistory } from 'react-router-dom'
import InfoTipoCambio from "./../../../../global/InfoTipoCambio"

export default function BarraSuperior({ classes, handleDrawerOpen, open }) {
  const classesAppBar = styles();
  const history = useHistory();
  const ClickCloseSession = () => {
    localStorage.removeItem(AUTH_CREDENTIALS_NAME)
    localStorage.removeItem(AUTH_USERS_NAME)
    history.push("/")
  }
  return (
    <AppBar
      position="fixed"
      style={{ zIndex: "1000" }}
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
      color="primary"
    >
      <Toolbar className={classesAppBar.barraDoodo} style={{minHeight: "40px"}}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, open && classes.hide)}
        >
          <MenuIcon />
        </IconButton>

        <img src={LogoDooddo} className={classesAppBar.logoAppBar} alt="logo" />

        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={ClickCloseSession}
          className={classes.menuButton}
        >
          <ExitToAppIcon />
        </IconButton>
      </Toolbar>
      <InfoTipoCambio DisabledPadding={true} />
    </AppBar>
  );
}